import { Api } from "./Api.class";
const endpoint = "chat";
const chatAPI = new Api(endpoint);
export default chatAPI;
